const UnknownActionType = 'RedirectType is unknown:';

export default {
  UnknownActionType,
};
